__turbopack_context__.v({
  "buttons": "Feedback-module-scss-module__d3lk7a__buttons",
  "fadeInUp": "Feedback-module-scss-module__d3lk7a__fadeInUp",
  "feedbackContainer": "Feedback-module-scss-module__d3lk7a__feedbackContainer",
  "inline": "Feedback-module-scss-module__d3lk7a__inline",
  "message": "Feedback-module-scss-module__d3lk7a__message",
});
